
import { Component, Vue } from 'vue-property-decorator';

import AutoCompleteField from '../../../../framework/fields/AutoCompleteField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import { sharedState } from '../../../../framework/state';
import { getOptionLabel } from '../../../../framework/service/options';
import { getResourcePagingNew, getResourcesNew } from '../../../../framework/client/resource';

import AutoCompleteMultipleField from '../../../fields/AutoCompleteMultipleField.vue';

import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { getCustomerOptions } from '../../../service/application_options_service';
import { dateToDbDateString } from '../../../../../common/framework/util/convert';
import { NetwheelsRequest } from '../../../../../common/application/model/NetwheelsRequest';
import ParameterService from '../../../service/parameter_service';

@Component({
    components: {
        SelectField,
        AutoCompleteField,
        AutoCompleteMultipleField,
    },
})
export default class NetwheelsRequests extends Vue {
    readonly resourceType = ApplicationResource.NETWHEELS_QUERY;
    parameterService = new ParameterService(this.resourceType);

    shared = sharedState;
    local = {
        rows: [] as NetwheelsRequest[],
        total: 0,
        loading: false,
        parameters: this.parameterService.get(),
        customerOptions: [] as { id: string | undefined; label: string }[],
    };

    async mounted() {
        await this.loadAsyncData();
    }

    async loadAsyncData() {
        this.local.loading = true;

        const backendParameters = this.parameterService.getBackendParameters();
        this.local.total = (await getResourcePagingNew(this.resourceType, backendParameters)).rowCount;

        this.local.rows = [];

        const rows = (await getResourcesNew(
            this.resourceType,
            this.local.parameters.page,
            backendParameters,
        )) as NetwheelsRequest[];
        rows.forEach((row) => {
            this.local.rows.push(row);
        });

        this.local.customerOptions = await getCustomerOptions();

        this.local.loading = false;
    }

    async onSortChange(field: string, order: 'desc' | 'asc') {
        this.local.parameters.sortField = field;
        this.local.parameters.sortOrder = order;
        await this.resetPagingAndLoadData();
    }

    async onPageChange(page: number) {
        this.local.parameters.page = page;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }

    dropdownClosed(resourceIds: string[], idField: string): void {
        if (this.local.loading) {
            return;
        }

        if (!resourceIds.length) {
            delete this.local.parameters[idField];
        } else {
            this.local.parameters[idField] = resourceIds;
        }

        this.resetPagingAndLoadData();
    }

    async resetFilter(): Promise<void> {
        this.local.parameters = this.parameterService.getDefault();
        await this.resetPagingAndLoadData();
    }

    getCustomerName(id: string): string {
        return getOptionLabel(id, this.local.customerOptions);
    }

    dateToString(date: string | undefined): string {
        if (!date) {
            return '';
        }

        return dateToDbDateString(new Date(date));
    }

    onRowClick(row: NetwheelsRequest) {
        return (this.$refs.table as Vue & { toggleDetails: (row: NetwheelsRequest) => boolean }).toggleDetails(row);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    get customerIds(): string[] {
        return this.local.parameters.customerId || [];
    }

    private async resetPagingAndLoadData() {
        this.local.parameters.page = 1;
        this.parameterService.set(this.local.parameters);
        await this.loadAsyncData();
    }
}
